module.exports = __webpack_public_path__ + "media/images/common/order_product-bba28b536dcf641ab4b20bb33d580bd5.png";